import axios from "axios";
import api from "../API/interceptors";

export const getReports = async (id, jwt) => {
    try {
        // const response = await axios.get(`${process.env.REACT_APP_API_URL}/reports/student/${id}/history`, {
        //     headers: {
        //         Authorization: `Bearer ${jwt}`,
        //     },
        // });
        const response = await api.get(`${process.env.REACT_APP_API_URL}/reports/student/${id}/history`);
        return response.data;
    } catch (error) {
        console.error('Get reports error:', error.response?.data || error.message);
        throw error;
    }
};


export const getSingleReport = async (id, jwt) => {
    try {
        // const response = await axios.get(`${process.env.REACT_APP_API_URL}/reports/${id}`, {
        //     headers: {
        //         Authorization: `Bearer ${jwt}`,
        //     },
        // });
        const response = await api.get(`${process.env.REACT_APP_API_URL}/reports/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get reports error:', error.response?.data || error.message);
        throw error;
    }
};